import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IMG_BASE_URL } from "../../../../config/Config";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Home_Best_Selling_Products = (homeData) => {
    const best_selling_product = homeData?.data?.best_selling_product?.slice(0, 9)
    const navigate = useNavigate();
    const sliderRef = useRef(null);
    const [Best_Selling_Products, setBest_Selling_Products] = useState(best_selling_product || [])
    const productCount = Best_Selling_Products?.length || 0;
    const slidesToShowProduct = Math.min(productCount, 5) || 1;

    const productSliderSettings = {
        infinite: productCount > slidesToShowProduct,
        speed: 500,
        slidesToShow: slidesToShowProduct,
        slidesToScroll: 1,
        autoplay: productCount > slidesToShowProduct,
        autoplaySpeed: 2500,
        arrows: productCount > slidesToShowProduct,
        pauseOnHover: false,
        pauseOnFocus: false,
        cssEase: "linear", // Helps with smooth autoplay
        variableWidth: false,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.min(productCount, 3),
                    infinite: productCount > 3,
                    autoplay: productCount > 3,
                    arrows: productCount > 3,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: Math.min(productCount, 2),
                    infinite: productCount > 2,
                    autoplay: productCount > 2,
                    arrows: productCount > 2,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    infinite: productCount > 1,
                    autoplay: productCount > 1,
                    arrows: productCount > 1,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                },
            },
        ],
    };

    useEffect(() => {
        if (Best_Selling_Products && sliderRef.current) {
            sliderRef.current.slickPlay();
        } else {
            sliderRef.current?.slickPause();
        }
    }, [Best_Selling_Products]);

    return (
        <div>
            <section className="gi-product-tab gi-products py-[40px] max-[767px]:py-[30px] wow fadeInUp" data-wow-duration="2s">
                <div
                    className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1450px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                    <div className="gi-tab-title grid grid-cols-1 gap-3 items-center w-full">
                        <div className="gi-main-title text-center">
                            <div className="section-title">
                                <div className="section-detail">
                                    <h2 className="bodonibook_font text-3xl text-gray-900 font-bold capitalize">
                                        Best selling Products</h2>
                                    <p className="mt-[5px] text-[14px] font-semibold text-gray-700 capitalize">Our
                                        fashion jewellery is inspired</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="w-full mb-1 px-[15px]">
                        <div className="col">
                            <div className="tab-content" id="myproTabContent">
                                <div className="tab-pro-pane best_selling_pr" id="snack">
                                    {Best_Selling_Products?.length > 0 ? (<Slider ref={sliderRef} {...productSliderSettings} className="w-full z-0">
                                        {/* {Best_Selling_Products?.length > 0 ? ()} */}
                                        {Best_Selling_Products?.map((product_list_result) => {
                                            const isOutOfStock = product_list_result?.current_stock <= 0;
                                            return (
                                                <div key={product_list_result?.id} className="p-3">
                                                    <div
                                                        onClick={() =>
                                                            navigate(`/product/${product_list_result?.slug
                                                                }`)
                                                        }
                                                        className={`gi-product-content h-full ${isOutOfStock ? "opacity-50 pointer-events-none" : ""}`}
                                                    >
                                                        <div className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer rounded-lg overflow-hidden shadow-custome">
                                                            <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                                                                <div className="gi-pro-image overflow-hidden">
                                                                    <a className="image productimg7 relative block overflow-hidden">
                                                                        {product_list_result?.product_images &&
                                                                            product_list_result?.product_images[0]?.file_type === "image" ? (
                                                                            <img
                                                                                className="main-image min-w-full transition-all duration-[0.3s] ease delay-[0s] object-cover aspect-[calc(4*3+1)/12]"
                                                                                src={`${IMG_BASE_URL}${product_list_result?.product_images[0]?.image_url}`}
                                                                                alt={product_list_result?.alt_image_title
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            <video controls autoplay className="main-image min-w-full transition-all duration-[0.3s] ease delay-[0s] object-cover aspect-[calc(4*3+1)/12]">
                                                                                <source
                                                                                    src={product_list_result?.product_images[0]?.video_url}
                                                                                    type="video/mp4"
                                                                                />
                                                                            </video>
                                                                        )}
                                                                    </a>
                                                                    {isOutOfStock && (
                                                                        <div className="absolute top-2 right-2 bg-red-600 text-white text-sm px-2 py-1 rounded">
                                                                            Out of Stock
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="gi-pro-content h-full p-[15px] md:p-[25px] md:pt-[12px] relative z-[10] flex flex-col text-center">
                                                                <a href="#">
                                                                    <h5 className="gi-pro-stitle text-[15px] font-semibold text-gray-900 truncate overflow-hidden whitespace-nowrap">
                                                                        {product_list_result?.name}
                                                                    </h5>
                                                                </a>

                                                                <div className="gi-pro-rat-price mb-[0] flex flex-col">
                                                                    <span className="gi-price">
                                                                        <span className="new-price text-gray-700 font-medium text-[13px]">
                                                                            Rs.{product_list_result?.purchase_price}/-
                                                                        </span>
                                                                    </span>
                                                                </div>

                                                                <button
                                                                    type="button"
                                                                    className={`text-[12px] uppercase border border-gray-200 text-gray-900 font-semibold px-3 py-2 hover:bg-gray-300 mt-3 ${isOutOfStock ? "cursor-not-allowed" : ""
                                                                        }`}
                                                                    disabled={isOutOfStock}
                                                                >
                                                                    {isOutOfStock ? "Not Available" : "View More"}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </Slider>
                                    )
                                        : (
                                            <div className="text-center text-gray-500 py-10 text-lg">
                                                Product List Not Found
                                            </div>
                                        )}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="inline-block w-full text-center my-6 md:my-0"><button onClick={() => {
                        navigate("/all-best-selling-product", {
                            state: {
                                gemstone_product: Best_Selling_Products,
                                category_id: Best_Selling_Products && Best_Selling_Products[0]?.cat_id,
                            },
                        });
                    }} 
                        className="text-[13px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-3 hover:bg-red-700 hover:text-white">
                            View All</button></div>
                </div>
            </section>
        </div>
    )
}

export default Home_Best_Selling_Products



